import { render, staticRenderFns } from "./TheAuthorisedMenu.vue?vue&type=template&id=a38af29e&scoped=true&"
import script from "./TheAuthorisedMenu.vue?vue&type=script&lang=ts&"
export * from "./TheAuthorisedMenu.vue?vue&type=script&lang=ts&"
import style0 from "./TheAuthorisedMenu.vue?vue&type=style&index=0&id=a38af29e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38af29e",
  null
  
)

export default component.exports